import rpAPI from '../service/rpAPI.js';

class Settings {
  constructor() {
    this.ready = false;
    this.ready = this.init();
  }

  async init() {
    return await this.fetchSettings(1);
  }

  async fetchSettings(id = 1) {
    try {
      const response = await rpAPI.getSettings(id);
      if (!response || response.length === 0) {
        throw new Error("Cannot fetch settings");
      }
      Object.assign(this, response);
      if (rpAPI.settings) {
        Object.assign(this, rpAPI.settings);
      }
      return true;
    } catch (error) {
      throw error;
    }
  }

  async fetchOffDays(key) {
    try {
      const response = await rpAPI.getOffDays(key);
      if (!response || response.length === 0) {
         this.offDays = { [key]: [] };
      } else {
         this.offDays = { [key]: response[0] };
      }

      return this.offDays[key];
    } catch (error) {
      throw error;
    }
  }
}


const settings = new Settings();
export default settings;
